module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-banner-fd1262389d53e1df15abb807ad8baf0a.png";